import { createContext } from 'react';

export const RankContext = createContext({
  user: {},
  competitions: [],
  competition: {},
  sports: [],
  types: [],
  ranks: [],
});
